

import { Configuration } from '@azure/msal-browser';

// Configuration object for MSAL
export const msalConfig: Configuration = {
    auth: {
       // @ts-ignore
        clientId:  window.location.href.includes("http://localhost") ? process.env.REACT_APP_CLIENT_ID_DEV : process.env.REACT_APP_CLIENT_ID_PROD  ,
        authority:   window.location.href.includes("http://localhost") ?  process.env.REACT_APP_AUTHORITY_DEV : process.env.REACT_APP_AUTHORITY_PROD ,
        redirectUri:  window.location.href.includes("http://localhost") ?  process.env.REACT_APP_REDIRECT_URI_DEV : process.env.REACT_APP_REDIRECT_URI_PROD , 
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    }
};

// Scopes for login request
export const loginRequest = {
    scopes: ['openid', 'profile', 'User.Read']
};

// API endpoints and scopes
export const protectedResources = {
    graphMe: {
        endpoint: 'https://graph.microsoft.com/v1.0/me',
        scopes: ['openid', 'profile', 'User.Read']
    }
};

// Type for authentication context
export interface AuthContextType {
    isAuthenticated: boolean;
    user: {
        name: string;
        email: string;
    } | null;
    login: () => Promise<void>;
    logout: () => Promise<void>;
}

// Type for account information
export interface AccountInfo {
    name: string;
    username: string;
}

export const tokenRequest = {
    scopes: ['openid', 'profile', 'User.Read'],
    forceRefresh: false // Set to true to skip cache
};